import React from 'react';

import { ContainerFormField } from '../../../SignUpFormModule.styles';
import { GeneralInputFormControl } from '../../../../../../Components/Forms/Controls';
import { TextFieldTypes } from '../../../../../../Interfaces/Forms';
import { FieldNames } from '../../../../../../Interfaces/Auth';
import { labelsForm, placeholdersForm } from '../../../../../../Constants/Auth';

interface Props {}

const GeneralSection: React.FC<Props> = () => {
  return (
    <>
      <ContainerFormField>
        <GeneralInputFormControl
          name={FieldNames.Email}
          label={labelsForm[FieldNames.Email]}
          placeholder={placeholdersForm[FieldNames.Email]}
          fieldType={TextFieldTypes.Text}
          // disabled={disabledMode}
          required
          fullWidth
        />
      </ContainerFormField>
      <ContainerFormField>
        <GeneralInputFormControl
          name={FieldNames.Password}
          label={labelsForm[FieldNames.Password]}
          placeholder={placeholdersForm[FieldNames.Password]}
          fieldType={TextFieldTypes.Password}
          // disabled={disabledMode}
          required
          fullWidth
        />
      </ContainerFormField>
      <ContainerFormField>
        <GeneralInputFormControl
          name={FieldNames.Password2}
          label={labelsForm[FieldNames.Password2]}
          placeholder={placeholdersForm[FieldNames.Password2]}
          fieldType={TextFieldTypes.Password}
          // disabled={disabledMode}
          required
          fullWidth
        />
      </ContainerFormField>
    </>
  );
};

export default GeneralSection;
